import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './PregnancyGuide.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import WeekSlider from '../common/WeekSlider';
import ShareIcon from '../common/ShareIcon';
import withContext from "../../../withContext";

const service = new Service();

class PregnancyGuide extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let currentweek,image;

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData'] && window.__initialData__['initialData']['result']) {
            initialData = window.__initialData__['initialData']['result'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData'] && props.staticContext.initialData['initialData']['result']) {
                initialData = props.staticContext.initialData['initialData']['result'];
                currentweek = initialData['currentWeek'];
                image= initialData['images'][initialData['currentWeek']-1]['twodscan'];
            }
        }
        this.state = {
            toolsurls:{
                'communitydietplanpregnants':'/tools/pregnancy-diet-plan/',
                'communitybabysizecomparisonlanding':'/tools/baby-size-comparison/',
                'communitypregnancyinspectionlanding':'/tools/pregnancy-checkup-schedule/',
                'communityfetuslanding':'/tools/fetal-movement-tracker/',
                'communityweekfetaldevelopment':'/tools/pregnancy-week-by-week-tracker/',
                'communityfetalvideolanding':'/tools/fetal-development-video/',
                'babynameslanding':'/baby-names-finder/all/',
                'communitymybumpielanding':'/tools/my-baby-bump/'
            },
            initialData: initialData,
            WeekByweekdata: [],
            articlesData:[],
            currentweek:currentweek,
            image: image,
            image_2d: '',
            image_3d: '',
            clickwedWeek: 1,
            scrollwidth: '',
            halfwidth: '',
            weekwd: '',
            weeks: '',
            suggestedToolIcon:'',
            suggestedTools:'',
            IsExpected: false
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "pregguide/getweekbyweekpregnancyguidedes";
        let body = JSON.stringify({})
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        this.setState({ windowWidth: window.outerWidth});
        document.addEventListener("click", actions.domClick);
        // console.log("initialData==============================>", this.state.initialData);
        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.getWeekByWeekGuide();
            } else {
                localStorage.setItem('WeekByWeekData', JSON.stringify(this.state.initialData));
                this.weekbyweeklanding();
                this.loadStateData();
            }
        } else {
            if (localStorage.getItem('WeekByWeekData')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('WeekByWeekData')) });
                this.weekbyweeklanding();
                this.loadStateData();
            }
            service.hideLoader();
        }
    }
    // loadStateData() {
    //     setTimeout(() => {
    //         try {
    //             this.state.scrollwidth = document.querySelector('.week-by-week').offsetWidth;
    //             this.state.halfwidth = this.state.scrollwidth / 2;
    //             this.state.weekwd = document.querySelector('.week-bar li').offsetWidth;
    //             this.state.weeks = document.querySelectorAll('.week-bar li');
    //             let a;
    //             for (let j = 1; j <= document.querySelectorAll('.week-bar li').length; j++) {
    //                 let wd = j * this.state.weekwd;
    //                 if (wd > this.state.halfwidth) {
    //                     a = j - 1;
    //                     break
    //                 }
    //             }
    //             for (let i = 0; i <= document.querySelectorAll('.week-bar li').length; i++) {
    //                 if (this.state.weeks[i].classList.contains('sel-week')) {
    //                     document.querySelector('.weeks-section').scrollLeft = ((this.state.weekwd * (i - a)));
    //                     break
    //                 }
    //             }

    //         } catch (err) {
    //             return "";
    //         }
    //         service.loadImages();
    //     }, 50)
    // }
    loadStateData(retryCount = 0) {
        console.log("🟢 loadStateData() called");
      
        // setTimeout(() => {
          try {
            console.log("⏳ Starting DOM element lookups...");
      
            const weekByWeekEl = document.querySelector(".week-by-week");
            const weekItems = document.querySelectorAll(".week-bar li");
            const selectedWeek = document.querySelector(".week-bar li.sel-week");
            const weekBarEl = document.querySelector(".week-bar li");
            const weeksSectionEl = document.querySelector(".weeks-section");
      
            console.log("📘 Found Elements:", {
              weekByWeekEl,
              weekItemsCount: weekItems.length,
              selectedWeek,
              weekBarEl,
              weeksSectionEl,
            });
      
            if (!weekByWeekEl || !weekItems.length || !weekBarEl || !weeksSectionEl) {
              console.warn("⚠️ Missing required DOM elements — aborting loadStateData()");
              return;
            }
      
            // ⏳ Retry until sel-week exists (max 5 retries)
            if (!selectedWeek && retryCount < 5) {
              console.warn(`⏱️ sel-week not found yet (retry ${retryCount + 1}/5)...`);
              this.loadStateData(retryCount + 1);
              return;
            }
      
            this.state.scrollwidth = weekByWeekEl.offsetWidth;
            this.state.halfwidth = this.state.scrollwidth / 2;
            this.state.weekwd = weekBarEl.offsetWidth;
            this.state.weeks = weekItems;
      
            console.log("📏 Calculated Dimensions:", {
              scrollwidth: this.state.scrollwidth,
              halfwidth: this.state.halfwidth,
              weekwd: this.state.weekwd,
            });
      
            let a;
            for (let j = 1; j <= weekItems.length; j++) {
              let wd = j * this.state.weekwd;
              if (wd > this.state.halfwidth) {
                a = j - 1;
                console.log(`📍 Found midpoint index (a): ${a}`);
                break;
              }
            }
      
            // ✅ Find actual selected index
            const selectedIndex = Array.from(weekItems).findIndex(li =>
              li.classList.contains("sel-week")
            );
      
            if (selectedIndex !== -1) {
              const scrollValue = this.state.weekwd * (selectedIndex - a);
              weeksSectionEl.scrollLeft = scrollValue;
      
              console.log("🧭 Scrolling to selected week:", {
                selectedIndex,
                scrollValue,
                weekNumber: weekItems[selectedIndex].id,
              });
            } else {
              console.warn("⚠️ No sel-week found in DOM after retry.");
            }
      
          } catch (err) {
            console.error("❌ Error in loadStateData:", err);
            return "";
          }
      
          console.log("🖼️ Triggering service.loadImages()");
          service.loadImages();
        // }, 50);
      }
      
      
    getWeekByWeekGuide() {
        var postData = {}
        // var url = global.api_url + "pregguide/getweekbyweekpregnancyguidedes";
        var url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekGuide";
        service.postServiceCall(url, postData).then((json) => {
            console.log("json=======================>",json)
            if (json['result']) {
                this.setState({ initialData: json['result'],currentweek: json['result']['currentWeek'],
                image:json['result']['images'][json['result']['currentWeek']-1]['twodscan'] }, () => { this.weekbyweeklanding(); this.loadStateData(); });
                localStorage.setItem('WeekByWeekData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    weekbyweeklanding() {
        try {
            if (Object.keys(this.state.initialData).length > 0) {
                let ary = this.state.initialData;
                const currentweekId = ary.currentWeek - 1;
                if (ary['images']) {
                    this.setState({ WeekByweekdata: ary['images'] });
                }
                this.setState({ currentweek: ary['currentWeek'],
                image: ary.images[currentweekId].twodscan,
                suggestedToolIcon:ary.suggestedToolIcon,
                suggestedTools:ary.suggestedTools,
                articlesData:ary.articles
             });
            }
            this.loadweekbyweekTracker();
            service.hideLoader();
            service.loadImages();
        } catch (error) {
            console.error(error);
            service.hideLoader();
        }

    }
    loadweekbyweekTracker() {
        setTimeout(() => {
            if (!global.ftk) {
                // console.log("WeekInfo=====================>true",this.state.currentweek);
                actions.weekInfo(this.state.currentweek, this, 1, 'wbwG');

            } else {
                // console.log("WeekInfo=====================>1else",this.state.currentweek);
                let shadesli = document.querySelector('#week_' + this.state.currentweek);
                if (shadesli) {
                    // shadesli.classList.remove('sel-week');
                    if (shadesli.firstChild && shadesli.firstChild.children) {
                        // console.log("WeekInfo=====================>2else");
                        actions.weekInfo(this.state.currentweek, this, 1, 'wbwG');
                    }
                }
            }

        }, 50)
        // console.log("toolsurls============>",Object.keys(this.state.toolsurls));

    }
    likeArticle(articleId, artstatus, e, likecount) {
        let cls = e.target;
        if (global.ftk !== '') {
            service.showLoader();
            var postData = {
                "articleId": articleId,
                "actionStatus": artstatus
            }
                // var url = global.api_url + "breastfeeding/savefeedarticleslike";
                var url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekLike";
                service.postServiceCall(url, postData).then((json) => {
                    service.hideLoader();
                    // console.log("json1===============>",json);
                    if (json['result'] == "success" && artstatus == 1) {
                        cls.classList.add('likedArticle');
                        cls.nextSibling.firstElementChild.innerHTML = (++likecount);
                    }

                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
                return true;
           } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    viewArticle(articleId, articleUrl) {
        // console.log("viewArticle================>",articleUrl);
        let postData = {
            "articleId":articleId,
            "post_status":"publish"
        }
        // var url = global.api_url + "blogs/getarticlesdetails";
        var url = global.api_ci_url + "WeekByWeekGuide/getWeekByWeekViewArticle";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                // this.props.history.push(articleUrl);
                window.location.href=articleUrl;
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    selectimage(weekno, str) {
        if (navigator.onLine) {
            if (this.state.WeekByweekdata) {
                this.setState({ clickwedWeek: weekno })
                let shadesEl1 = document.querySelector('.scan_2D');
                let shadesEl2 = document.querySelector('.scan_3D');
                let shadesEl3 = document.querySelector('.scan_img');
                shadesEl3.classList.contains('scan_img');

                (weekno == "undefined" || weekno == "") ? weekno = weekno : weekno = weekno;
                if (this.state.WeekByweekdata[weekno - 1]) {
                    return (
                        str == "scan_3D" ? (this.setState({ image: this.state.WeekByweekdata[weekno - 1].threedscan }),
                            shadesEl2.classList.add('selectedimg'), shadesEl1.classList.remove('selectedimg'), shadesEl3.classList.remove('selectedimg'))
                            : str == "imageTab" ? (this.setState({ image: this.state.WeekByweekdata[weekno - 1].image }),
                                shadesEl3.classList.add('selectedimg'), shadesEl1.classList.remove('selectedimg')
                                , shadesEl2.classList.remove('selectedimg')) :
                                (this.setState({ image: this.state.WeekByweekdata[weekno - 1].twodscan }), shadesEl1.classList.add('selectedimg'),
                                    shadesEl3.classList.remove('selectedimg'), shadesEl2.classList.remove('selectedimg'))
                    )
                }
            }
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }
    shareIcon(id) {
        console.log("shareOn================>",id.target.parentNode);
        if(document.querySelector('.sharing-options').style.display!="block"){
            document.querySelector('.sharing-options').style.display="block";
        }else{
            document.querySelector('.sharing-options').style.display="none";
        }
        if (window.innerWidth < 767) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
    shareOn(id) {
        console.log("shareOn================>",id.target);
        let ary = document.querySelectorAll('.sharing-options').length
        for (let i = 0; i < ary; i++) {
            document.querySelectorAll('.sharing-options')[i].style.display = 'none';
        }
        id.target.nextSibling.style.display = 'block';
        
        if (window.innerWidth < 767) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
    shareTemplate(id,shareoption,imageUrl){
        console.log("shareTemplate====>",imageUrl);
        if (global.ftk) {
            console.log("non login");
            if (shareoption == "facebook" || shareoption == "whatsapp") {
                document.querySelector("meta[property='og\\:description']").content = "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your "+id+" weeks of pregnancy";
                document.querySelector("meta[property='og\\:image']").content = imageUrl;

            } else if (shareoption == "twitter" || shareoption == "pintrest") {
                document.querySelector("meta[property='twitter\\:description']").content = "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your "+id+" weeks of pregnancy";
                document.querySelector("meta[property='twitter\\:image']").content = imageUrl;
                document.querySelector("meta[property='twitter\\:title']").content = "PARENTING.FIRSTCRY.COM";
            }
            actions.shareArticle(shareoption, global.currentURL);
        } else {
            console.log("non login========>1");
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }   
    }
    changeData(id, type, status) {
        let articlesData = this.state.articlesData;
        articlesData[this.state.clickwedWeek-1].articles && articlesData[this.state.clickwedWeek-1].articles.forEach((articles) => {
            if (articles.articleId == id) {
                if (type == "bookmark") {
                    if (parseInt(status) == 1) {
                        // console.log("successss====>",articles.articleId);
                        articles.isBookmarked = true;
                        articles.bookmarkCount = parseInt(articles.bookmarkCount) + 1;
                    } else if (parseInt(status) == 0) {
                        articles.isBookmarked = false;
                        articles.bookmarkCount = parseInt(articles.bookmarkCount) - 1;
                    }
                }
            }
        });
        // console.log("this.state.articlesData===================>",this.state.articlesData);
        // console.log("articlesData===================>",articlesData);
        this.setState({ articlesData: articlesData });
    }

   
    setBookMark(e,articleId, status) {
        let cls = e.target;
        let count=parseInt(cls.parentNode.nextSibling.innerHTML);
        console.log("cls.parentNode.nextSibling=========>",cls.parentNode.nextSibling);
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "articleId": articleId,
                "status": status.toString()
            }
            var url = global.api_ci_url + "DietplanBaby/setBookMark";
            service.postServiceCall(url, postData).then((json) => {
                if (json['msg'] == "1") {
                    this.changeData(articleId, "bookmark", status);
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    render() {

        return (
            <main className="main-container pregnacyGuide">
                <Helmet
                    title="Pregnancy Week by Week Calendar - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "Learn about your pregnancy symptoms, your’s baby growth & development and diet to follow right from week 1 to until the birth of baby in our week by week pregnancy calendar." },
                        { "name": "keywords", "content": "pregnancy calendar, pregnancy tracker, pregnancy calendar week by week, weekly pregnancy calendar" },
                        { "name": "atdlayout", "content": "tools_sp" },
                        { "property": "og:locale", "content": "en_US" },
                        { "property": "og:type", "content": "website" },
                        { "property": "og:title", "content": "PARENTING.FIRSTCRY.COM" },
                        { "property": "og:description", "content": "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your "+this.state.currentweek+" weeks of pregnancy" },
                        { "property": "og:url", "content": global.currentURL },
                        { "property": "og:image", "content": this.state.image },
                        { "property": "twitter:image", "content": this.state.image },
                        { "property": "twitter:title", "content": "PARENTING.FIRSTCRY.COM" },
                        { "property": "twitter:description", "content": "Check out this helpful week-byweek guide to pregnancy so you know exactly what to expect in your "+this.state.currentweek+" weeks of pregnancy" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Pregnancy Week by Week</span>
                    </div>
                    <div className="preg-guide">
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>Pregnancy Week by Week {global.userAry['userName'] ? "for (" + (global.userAry['userName'] + ")") : null}</h1>
                        <ShareIcon eleRef={this} tool={'wbwG'}/>
                    </div>
                </div>
                <div className="sub-container left">
                    <div className="week-by-week data-container left pregnancy-week-by-week-tool">
                        <div className="baby-size-weeks">
                            <WeekSlider eleRef={this} WeekBdata={this.state.WeekByweekdata} weekKey={'week'} keyVal={1} tool={'wbwG'} />
                        </div>
                        <div className="card_container">
                            <div className="card_container-title" style={{display: 'none'}}>
                                <span className="B20_42">
                                    Your Baby's Growth During Pregnancy-Week  {this.state.clickwedWeek ? this.state.clickwedWeek : null}
                                    <span className="pregCurWk"></span>
                                </span>
                            </div>
                            <div className="weekbyweek_cont"  style={{display: 'none'}}>
                                <div className='weekbyweek for_2d'>
                                    <section className="tabs_cont">
                                        <div className="scan_2D selectedimg" onClick={() => { this.selectimage(this.state.clickwedWeek, "scan_2D") }}>
                                            <span className="M14_42 dev2Dscan">2D Scan</span>
                                        </div>
                                        <div className="scan_3D" onClick={() => { this.selectimage(this.state.clickwedWeek, "scan_3D") }}>
                                            <span className="M14_9e dev3Dscan">3D Scan</span>
                                        </div>
                                        <div className="scan_img" onClick={() => { this.selectimage(this.state.clickwedWeek, "imageTab") }}>
                                            <span className="M14_9e devscanimg">Image</span>
                                        </div>
                                    </section>
                                    <section className="view_image 2d_image">
                                        <img className="ga-img" src={`${this.state.image}`.replace(/\.jpg$/i, ".webp")} alt="" title="" />
                                    </section>
                                </div>
                            </div>
                            <div className="R14_9e trimester-section"  style={{display: 'none'}}>
                                <span className="R14_9e trimester"></span>
                                <span className="R14_9e trimesterdays"></span>
                            </div>
                            {/* <!--Size Info--> */}
                            <div className="baby-size-info"  style={{display: 'none'}}>
                                <div className="baby-size M18_42">
                                    <span className="baby-sizeCurrWk"></span> weeks baby size
                            </div>
                            </div>
                            <div className="size-desc"  style={{display: 'none'}}>
                                <div className="size-info">
                                    <div className="len-txt">Length</div>
                                    <div className="length B17_42"></div>
                                </div>
                                <div className="size-info-line"></div>
                                <div className="size-info">
                                    <div className="wgt-txt">Weight</div>
                                    <div className="weight B17_42"></div>
                                </div>
                            </div>
                            {/* <ShareIcon eleRef={this} tool={'wbwG'}/> */}
                            <div className="border-bottom"></div>
                            {/* <!-- articles section --> */}
                            <div className="pregnancy-guide-article">
                            {this.state.articlesData && this.state.articlesData[this.state.clickwedWeek-1] && this.state.articlesData[this.state.clickwedWeek-1].articles && this.state.articlesData[this.state.clickwedWeek-1].articles.length > 0 && this.state.articlesData[this.state.clickwedWeek-1].articles.map((articles, index1) =>
                                <div key={index1} className="preg-article" id={'art-' + articles.articleId}>
                                    <span  className="B20_42 card-title" onClick={(e) => this.viewArticle(articles.articleId,articles.articleUrl)}>
                                        {articles.articleTitle}
                                    </span>
                                    <div  className="article_image" onClick={(e) => this.viewArticle(articles.articleId,articles.articleUrl)}>

                                        <img  className="ga-img" src={`${articles.articleImage}`.replace(/\.jpg$/i, ".webp")} alt="" title="" />
                                    </div>
                                    <div  className="article-txt">
                                        <span  className="R14_61">
                                            {articles.articleText}
                                        </span>
                                    </div>
                                    <span  className="R14_link read-more" onClick={(e) => this.viewArticle(articles.articleId,articles.articleUrl)}>Read More</span>
                                    <div  className="article-social">
                                        <div  className="card-views social-action">
                                            <span  className="icon M14_42 view-icon" data-icon-font="$" onClick=""></span>
                                            <span  className="view-count M14_42">
                                                {articles.viewCount}
                                            Views
                                            </span>
                                        </div>
                                        <div  className="card-likes social-action">
                                            {articles.isLiked ? 
                                            (
                                            <span  className="icon M14_42 likedArticle" data-icon-font="T" id={'like_' + articles.articleId} onClick={(e)=> this.likeArticle(articles.articleId ,0,e,articles.likeCount)}>
                                            </span>):
                                            (
                                            <span  className="icon M14_42 like-icon" data-icon-font="T" id={'like_' + articles.articleId} onClick={(e)=> this.likeArticle(articles.articleId,1,e,articles.likeCount)}>
                                            </span>)
                                        }
                                            <span  className="total-likes M14_42 view-count">
                                                <span  className="artlikeCount">
                                                    {articles.likeCount}
                                                </span>
                                                 Likes</span>
                                        </div>
                                        <div className="social-actions">
                                            {articles['isBookmarked'] ?
                                                (<span className="icon bookmarkicon active" onClick={(e) => { this.setBookMark(e,articles['articleId'], 0) }}>
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/bookmark.png" />
                                                </span>)
                                                :
                                                (<span className="icon bookmarkicon" onClick={(e) => { this.setBookMark(e,articles['articleId'], 1) }}>
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/unbookmark.png" alt="Unbookmark Icon" title="Unbookmark Icon" />
                                                </span>)
                                            }
                                            <span className="bookmark-count M14_42">{service.intToString(articles['bookmarkCount'])} Bookmarks</span>
                                        </div>
                                        <div  className="card-share right social-action">
                                            <span  className="icon M14_42 share-icon" data-icon-font=")" onClick={(e) => this.shareOn(e)}>
                                            </span>
                                            <div className="sharing-options">
                                                <ul className="left">
                                                    <li className="whatsapp-share left" onClick={(e) => actions.shareArticle('whatsapp',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="whatsapp">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                                                        </span>
                                                    </li>
                                                    <li className="facebook-share left" onClick={(e) => actions.shareArticle('facebook',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="facebook">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                                                        </span>
                                                    </li>
                                                    <li className="twitter-share left" onClick={(e) => actions.shareArticle('twitter',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="twitter">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                                                        </span>
                                                    </li>
                                                    <li className="twitter-share left" onClick={(e) => actions.shareArticle('pintrest',articles['articleUrl'])}>
                                                        <span className="M16_61 social-share" id="pintrest">
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}
                            </div>

                            <div className="share-overlay"></div>
                        </div>
                        <div className="suggested-tool">
                            <span className="B20_42 suggested-tool-title">
                                <img src={this.state.suggestedToolIcon} className="suggested-img"/>
                                    Suggested Tools For You
                                    </span>
                                <ul className="suggested-tool-list">
                                {this.state.toolsurls && this.state.suggestedTools && this.state.suggestedTools.length > 0 && this.state.suggestedTools.map(suggtools=>
                                    <li className="tool-list tool1" onClick={(e)=>{suggestedtools(e)}}>
                                        {this.state.toolsurls  &&  Object.keys(this.state.toolsurls).length > 0 && Object.keys(this.state.toolsurls).map((urls, key)=>Object.keys(this.state.toolsurls)[key]==suggtools.appUrl[0].pagetype ?
                                        (
                                        <a href={"//parenting.firstcry.com"+this.state.toolsurls[urls]}>
                                                <img src={suggtools.coverImageUrl} className="img-style" />
                                                    <div className="img-txt">
                                                        {suggtools.title}
                                                    </div>
                                                    <div className="bottom-shadow"></div>
                                        </a>
                                        )
                                        :(null) 
                                        )}
                                    </li>
                                    )} 
                            </ul> 
                        </div> 
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(PregnancyGuide);
